import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const CreditDataSubtitleForm = styled.h6`
  color: ${colors.textPrimary};
  font-size: 16px;
  line-height: 23px;
  margin-top: 30px;
  font-weight: 600;
`;

export const CreditDataFieldContent = styled.div``;

export const CreditDataFieldInputTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CreditDataFieldTitleValorLabel = styled.label`
  color: ${colors.textPrimary};
  opacity: 0.9;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
`;

export const CreditDataFieldTitleValorDeleteItem = styled.span`
  cursor: pointer;
  color: ${colors.bgDanger};
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
`;

export const CreditDataButtoCalculate = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${prop => prop.align ? 'space-between' : 'flex-end'};
  margin-top: 29px;
  margin-bottom: 23px;
`;

export const CreditDataAddButton = styled.span`
  color: ${colors.bgSecondary};
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
  text-decoration: underline;
`;
